import { createAction } from '@reduxjs/toolkit'

export const exportAllCheckin = createAction('checkin/exportAllCheckin')
